import * as fieldsList from "@/components/dialogs/RequestDialog.new/fields-to-send";
import axios from "axios";
import endpoints from "@/api/endpoints";

/**
 * @class RequestService - Класс для подготовки и отправки данных формы создания обращения.sss
 */
class RequestDialogService {
  /**
   * @param { Object } form - Принимает в качестве аргумента объект form который содержит в себе данные из формы (key/value).
   */
  constructor(form) {
    this.form = form;
  }

  /**
   * Метод для подготовки данных.
   * @param type - Имя свойства в объекте fieldList. По нему получаем массив полей формы, которые надо отправить.
   * @param fields - Доп поля, по дефолту пустой массив
   * @return { Object } - Возвращает formData
   */
  getPreparedData(type, fields = []) {
    /**
     * Объединяем поля, которые находятся в HeaderForm с полями из текущего компонента формы, который выбирается
     * при изменении темы, группы или процесса запроса. Поля в компоненте HeaderForm всегда обязательны к отправке.
     */
    const currentFieldList = [
      ...fieldsList.BaseForm,
      ...fieldsList[type],
      ...fieldsList.HeaderForm,
      ...fields
    ];
    const preparedData = new FormData();

    /**
     * Добавляем прикрепленныей файлы в formData
     */
    this.form.files.forEach((file, index) =>
      preparedData.append(`files-${index}`, file)
    );
    /**
     * Добавляем в formData поля с значениями получаемыми с помощью метода getValueByKey
     */
    currentFieldList.forEach(key => {
      preparedData.append(key, this.getValueByKey(key, this.form[key]));
    });

    return preparedData;
  }

  /**
   * Метод для получения данных поля по его ключу. В зависимости от поля,
   * данные из value вытаскиваются по разному. Если поле не описано в case, то возвращается
   * просто value.
   *
   * @param { String } key - Свойство
   * @param { String | Object | Array } value - Его значние
   * @return { string | number | Array }
   */
  getValueByKey(key, value) {
    switch (key) {
      case "company":
        return value.id;

      case "themes":
        return value.request_theme_id;

      case "articles":
        return value.map(article => article?.pdm_elementid || article);

      case "process":
      case "group":
        return value.id;

      case "article_element":
      case "disassembling_article_element":
        return value?.pdm_elementid || value;

      case "article_original":
      case "disassembling_article_original":
        return value?.pdm_oemarticle || value;

      case "request_form":
      case "service_engineer":
      case "request_reason":
      case "disassembling":
      case "damage_1":
      case "damage_2":
        return value?.title;
    }

    return value || "";
  }

  /**
   * @param { Object } data
   * @return { Promise<{date: string, themes: [string], message_counter: string, description: string, files: [], messages: [{date: string, author: string, files: [{name: string, href: string}], id: number, message: string},{date: string, author: string, id: number, message: string}], id: string, title: string, deadline: string, timestamp: string, status: string}>}
   */
  async sendData(data) {
    return await axios
      .post(endpoints.requests.sendRequest, data)
      .then(res => res.data?.request_info);
  }
}

export default RequestDialogService;
